export enum FigureVarType {
  list = "list",
  number = "number",
  string = "string",
  select = "select",
  variable = "variable",
}

export interface FigureVarSelectSettings {
  type: FigureVarType.select;
  defaultValue?: string;
  label: string;
  options: string[];
  varName: string;
}

export interface FigureVarStandardSettings {
  type: FigureVarType.list | FigureVarType.number | FigureVarType.string | FigureVarType.variable;
  defaultValue?: string;
  label: string;
  varName: string;
}

export type FigureVarSettings = FigureVarSelectSettings | FigureVarStandardSettings;

/**
 * Type guard to check if an object is a FigureVarSettings
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureVarSettings
 */
export const isFigureVarSettings = (obj: unknown): obj is FigureVarSettings => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureVarSettings;
  if (typeof chkObj.varName !== "string") {
    return false;
  }
  if (typeof chkObj.label !== "string") {
    return false;
  }
  if (
    chkObj.type !== "list" &&
    chkObj.type !== "number" &&
    chkObj.type !== "string" &&
    chkObj.type !== "select" &&
    chkObj.type !== "variable"
  ) {
    return false;
  }
  if (chkObj.type === FigureVarType.select) {
    const selectObj = chkObj as FigureVarSelectSettings;
    if (
      !Array.isArray(selectObj.options) ||
      selectObj.options.some((opt) => typeof opt !== "string")
    ) {
      return false;
    }
  }
  if (chkObj.type !== FigureVarType.select && "options" in chkObj) {
    return false;
  }
  return true;
};
